import { getEndpointUrl, useEndpoint } from 'api';
import { useUserContext } from 'contexts';
import type { InvoiceResponse, OrdersResponse } from 'models/api';
import { is } from 'utils/helpers';

import usePagedData from './usePagedData';

export function useBonusBalance() {
	const { customerType } = useUserContext();

	return useEndpoint('GetCustomerBonus', {
		isActive: is.oneOf(customerType, 'Pro', 'Club'),
	});
}

export function useOrderHistory(isActive: boolean = true, pageSize?: number) {
	return usePagedData<OrdersResponse, 'transactions'>({
		baseUrl: getEndpointUrl('GetCustomerOrders'),
		itemsKey: 'transactions',
		isActive,
		pageSize,
	});
}

export function useInvoices(isActive: boolean = true, pageSize?: number) {
	return usePagedData<InvoiceResponse, 'invoices'>({
		baseUrl: getEndpointUrl('GetCustomerInvoices'),
		itemsKey: 'invoices',
		isActive,
		pageSize,
	});
}
